import { render, staticRenderFns } from "./update-session.vue?vue&type=template&id=4a3f0dec"
import script from "./update-session.vue?vue&type=script&lang=js"
export * from "./update-session.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports